import React from "react"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { withMicrocopy } from "~contexts/MicrocopyContext"
import Link from "~components/Link"
import * as style from "./Teaser.module.scss"

import youtubeImage from './youtube.png'
import newsletterImage from './newsletter.png'
import blogImage from './blog.png'

const Teaser = ({ microcopy }) => (
  <div className={style.teaserWrapper}>
    <Link to={microcopy.text("pages.additionalResources.youtube.url")} className={style.teaser}>
      <LazyLoadImage
        className={style.image}
        src={youtubeImage}
        alt=""
        width={385}
        height={255}
      />
      <h3 className={style.title}>
        {microcopy.text("pages.additionalResources.youtube.title")}
      </h3>
      <p>
        {microcopy.text("pages.additionalResources.youtube.text")}
      </p>
      <p>
        {microcopy.text("pages.additionalResources.youtube.cta")}
      </p>
    </Link>
    <Link to={microcopy.text("pages.additionalResources.newsletter.url")} className={style.teaser}>
      <LazyLoadImage
        className={style.image}
        src={newsletterImage}
        alt=""
        width={385}
        height={255}
      />
      <h3 className={style.title}>
        {microcopy.text("pages.additionalResources.newsletter.title")}
      </h3>
      <p>
        {microcopy.text("pages.additionalResources.newsletter.text")}
      </p>
      <p>
        {microcopy.text("pages.additionalResources.newsletter.cta")}
      </p>
    </Link>
    <Link to={microcopy.text("pages.additionalResources.blog.url")} className={style.teaser}>
      <LazyLoadImage
        className={style.image}
        src={blogImage}
        alt=""
        width={385}
        height={255}
      />
      <h3 className={style.title}>
        {microcopy.text("pages.additionalResources.blog.title")}
      </h3>
      <p>
        {microcopy.text("pages.additionalResources.blog.text")}
      </p>
      <p>
        {microcopy.text("pages.additionalResources.blog.cta")}
      </p>
    </Link>
  </div>
)

export default withMicrocopy(Teaser)
